// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"fa910a49","732":"760ff765","977":"a84adce0"}[chunkId] + ".chunk.js";
};